import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";

const ResetPassword = () => {
  const navigate = useNavigate();
  const axiosPrivate = useAxiosPrivate();

  const [user, setUser] = useState("");
  const [otp, setOtp] = useState("");
  const [pwd, setPwd] = useState("");
  const [errMsg, setErrMsg] = useState("");
  const [successMsg, setSuccessMsg] = useState("");
  const [loading, setLoading] = useState(false);

  const handleOTP = async (e) => {
    setLoading(true);
    e.preventDefault();
    setErrMsg("");
    setSuccessMsg("");
    try {
      const response = await axiosPrivate.post(`/requestotp/${user}`);

      setSuccessMsg("OTP sent to your email successfully");
      setLoading(false);
    } catch (err) {
      setLoading(false);
      console.error(err);
      if (err?.response?.status === 400) {
        setErrMsg("OTP already requested. Wait for 3 mins before trying again");
      } else if (err?.response?.status === 401) {
        setErrMsg("User not found");
      } else if (err?.response?.status === 500) {
        setErrMsg("Failed to send OTP due to an internal error");
      } else {
        setErrMsg(err?.response?.data?.message || err?.message);
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrMsg("");
    setSuccessMsg("");
    setLoading(true);
    try {
      const response = await axiosPrivate.post(
        "/resetpassword",
        JSON.stringify({ user, otp, pwd })
      );

      setSuccessMsg("Password reset successfully");
      setTimeout(() => {
        navigate("/login");
      }, 2000);
    } catch (err) {
      console.error(err);
      if (err?.response?.status === 400) {
        setErrMsg("Missing or invalid parameters");
      } else if (err?.response?.status === 401) {
        setErrMsg("User not found or OTP doesn't match");
      } else if (err?.response?.status === 500) {
        setErrMsg("Failed to update the password due to an internal error");
      } else {
        setErrMsg(err?.response?.data?.message || err?.message);
      }
    }
    setLoading(false);
  };

  return (
    <section className="lg:w-3/5 fade-in">
      <h1 className="text-4xl font-bold mb-2 text-center">Reset Password</h1>
      <p className="text-center text-base mb-8" style={{ color: 'var(--text-muted)' }}>
        Enter your username to receive a password reset OTP
      </p>

      {errMsg && <p className="errmsg">{errMsg}</p>}
      {successMsg && <p className="successmsg">{successMsg}</p>}

      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="user">Username / Email</label>
          <input
            type="text"
            id="user"
            value={user}
            onChange={(e) => setUser(e.target.value)}
            placeholder="Enter your username"
            required
            disabled={loading}
          />
        </div>

        {!otp && (
          <button
            type="button"
            className="btn-primary"
            onClick={handleOTP}
            disabled={!user || loading}
          >
            {loading ? "Sending OTP..." : "Request OTP"}
          </button>
        )}

        {otp && (
          <>
            <div className="form-group">
              <label htmlFor="otp">OTP Code</label>
              <input
                type="text"
                id="otp"
                value={otp}
                onChange={(e) => setOtp(e.target.value)}
                placeholder="Enter OTP from email"
                required
                disabled={loading}
              />
            </div>

            <div className="form-group">
              <label htmlFor="pwd">New Password</label>
              <input
                type="password"
                id="pwd"
                value={pwd}
                onChange={(e) => setPwd(e.target.value)}
                placeholder="Enter new password"
                required
                disabled={loading}
              />
              <p className="instructions">
                Password must be at least 8 characters long
              </p>
            </div>

            <button
              type="submit"
              className="btn-primary"
              disabled={!pwd || loading}
            >
              {loading ? "Resetting..." : "Reset Password"}
            </button>
          </>
        )}
      </form>

      <div style={{ marginTop: '1.5rem', textAlign: 'center' }}>
        <Link to="/login">
          <p style={{ fontSize: '0.875rem', color: 'var(--accent-cyan)' }}>
            ← Back to Sign In
          </p>
        </Link>
      </div>
    </section>
  );
};

export default ResetPassword;
